var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f0b841",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m10.67,0H3.43C1.54,0,0,1.54,0,3.43v11.43c0,1.89,1.54,3.43,3.43,3.43h9.14c1.89,0,3.43-1.54,3.43-3.43V5.33c0-.61-.24-1.19-.67-1.62l-3.05-3.05C11.86.24,11.27,0,10.67,0Zm3.05,14.86c0,.63-.51,1.14-1.14,1.14H3.43c-.63,0-1.14-.51-1.14-1.14V3.43c0-.63.51-1.14,1.14-1.14h7.24l3.05,3.05v9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m10.29,10.86h-4.57c-.63,0-1.14.51-1.14,1.14s.51,1.14,1.14,1.14h4.57c.63,0,1.14-.51,1.14-1.14s-.51-1.14-1.14-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m5.71,6.29c-.63,0-1.14.51-1.14,1.14s.51,1.14,1.14,1.14h4.57c.63,0,1.14-.51,1.14-1.14s-.51-1.14-1.14-1.14h-4.57Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportes);
export default __webpack_public_path__ + "static/media/reportes.2eb586b34eb9a32fabd819d4d6488b98.svg";
export { ForwardRef as ReactComponent };